import { createSlice } from '@reduxjs/toolkit';
import { AppThunk, RootState } from './index';
import { RegisterDetailsType } from '../types/helpers';
import { RegisterService } from '../services/RegisterService';
import { setIsRegistered, setModalSignInUp } from './AppSlice';
import { modalTypeEnum } from '../types/modal';
import { Api } from '../services/Api';
import { LoginResponse } from '../types/register';
import { setUserWallet } from './UserSlice';
import { addSpanErrorMessage, cleanSpanErrorMessage, setNotificationButtonLoad } from './NotificationSlice';
import { encryptionProcess, setAccessTokenLocally, setRefreshTokenForEncryption } from './EncryptionSlice';
import { walletNetworkVerification } from '../utils/verification';
import { errors } from '../types/errors';
import walletConnector from '../features/wallet-connector';

//const REGISTER_KEY = 'register';

const resetObject = {
    doc: null,
    name: null,
    email: null,
    mobile: null,
    street: null,
    number: null,
    comp: null,
    neighbourhood: null,
    state: null,
    zipcode: null,
    city: null
}

const initialState: RegisterDetailsType = {
    registerDetails: { ...resetObject },
    comingFromMetamask: false,
    blockChainAddress: '',
    blockChainVerificationPharse: '',
    blockChainNetwork: '',
    userSignature: '',
    password: '',
    nickname: '',
    isRegister: false
};

const registerSlice = createSlice({
    name: 'register',
    initialState,
    reducers: {
        setRegisterDetails: (state, action) => {
            const { field, value } = action.payload;
            if (field === 'doc') state.registerDetails['doc'] = value;
            if (field === 'name') state.registerDetails['name'] = value;
            if (field === 'email') state.registerDetails['email'] = value;
            if (field === 'mobile') state.registerDetails['mobile'] = value;
            if (field === 'zipcode') state.registerDetails['zipcode'] = value;
            if (field === 'street') state.registerDetails['street'] = value;
            if (field === 'number') state.registerDetails['number'] = value;
            if (field === 'comp') state.registerDetails['comp'] = value;
            if (field === 'neighbour') state.registerDetails['neighbourhood'] = value;
            if (field === 'city') state.registerDetails['city'] = value;
            if (field === 'state') state.registerDetails['state'] = value;
        },
        setIsComingFrmoBlockchain: (state, action) => {
            state.comingFromMetamask = action.payload;
        },
        setBlockChainAddress: (state, action) => {
            state.blockChainAddress = action.payload
        },
        setBlockChainVerificationPharse: (state,action) => {
            state.blockChainVerificationPharse = action.payload;
        },
        setUserSignature: (state, action) => {
            state.userSignature = action.payload
        },
        setNetwork: (state, action) => {
            state.blockChainNetwork = action.payload
        },
        setIncreaseModalStep: (state, action) => {
            state.isRegister = action.payload
        },
    }
});

export const { setRegisterDetails, setIsComingFrmoBlockchain, setBlockChainAddress, setUserSignature, setBlockChainVerificationPharse, setNetwork, setIncreaseModalStep } = registerSlice.actions

// GETTERS
export const getRegister = (state: RootState) => state.register.registerDetails;
export const getIsComingFromMetamask = (state: RootState) => state.register.comingFromMetamask;
export const getBlockchainAddress = (state: RootState) => state.register.blockChainAddress;
export const getBlockChainVerificationPharse = (state: RootState) => state.register.blockChainVerificationPharse;
export const getIncreaseModalStep = (state: RootState) => state.register.isRegister;
export const getBlockchainNetwork = (state: RootState) => state.register.blockChainNetwork;
export const getUserSignature = (state: RootState) => state.register.userSignature;


export const setRegisterReset = (state: RootState) => state.register.registerDetails = resetObject;
export const getRegisterStatus = (state: RootState): boolean => {
    return Object.values(state.register.registerDetails)
        .every(value => value !== null && value !== '');
}

export const getHomeAddress = (zipcode: string): AppThunk<Promise<void>> => async dispatch => {
    try {
        const response = await RegisterService.getLocationsAddress(zipcode);
        if (response) {
            console.dir('get address succesfully')

        } else {
            throw new Error('Invalid receipt format');
        }
    } catch (err) {
        console.error(err)
        console.error("ERRO NO REQUEST DA API para get info do CEP")
    }
}

export const makeRegisterAndLogin = (hash: string, pass: string, isLogin: boolean, nickname: string | ''): AppThunk<Promise<void>> => async (dispatch, getState) => {

    const state = getState();

    try {

        dispatch(cleanSpanErrorMessage())

        let registerLoginResponse: LoginResponse;
        
        localStorage.setItem('wallet', hash);
        dispatch(setUserWallet(hash));
        dispatch(setIsRegistered(isLogin));

        // Register = true
        if (!isLogin) {
            const chain = walletNetworkVerification(hash).toLocaleLowerCase();
            const registerResponse : any = await RegisterService.entityRegister(hash, pass, nickname, chain);
            if (registerResponse.code !== 201) {
                dispatch(setNotificationButtonLoad(false));
                dispatch(addSpanErrorMessage(errors(registerResponse.response.data.code)))
                return;
            }
        }

        // Register = false
        registerLoginResponse = await RegisterService.entityLogin(hash, pass);
        dispatch(setNotificationButtonLoad(false));
        if (registerLoginResponse.code === 201) {

            Api.setToken(registerLoginResponse.data.token);
            dispatch(setIsRegistered(true));
            dispatch(setRefreshTokenForEncryption(registerLoginResponse.data.refresh_token));
            dispatch(setAccessTokenLocally(registerLoginResponse.data.token));

            try {
                await encryptionProcess();
                dispatch(setModalSignInUp(modalTypeEnum.deviceLogin));
            } catch (err) {
                console.dir('Error Register Slice - 001');
                //dispatch(setModalSignInUp(modalTypeEnum.unauthorized));
            }

        } else {
            dispatch(addSpanErrorMessage("ERRO - Credenciais invalidas"))
            throw new Error('ERRO - Login incorrecto')
        }
        

    } catch (err) {
        console.error('Error Signup Signin')
        console.error(err);
    } finally {
        dispatch(setNotificationButtonLoad(false));
    }
}

export const getUserPhrase = (acc:string) : AppThunk<Promise<void>> => async (dispatch, getState) => {

    const state = getState();
    let chain = '';
    if (state.register.blockChainNetwork === 'eth_flow') chain = 'ethereum-chain';
    if (state.register.blockChainNetwork === 'tron_flow') chain = 'tron-chain';
    const phrase: any = await RegisterService.getUserPhrase(acc, chain);

    if (!phrase?.data?.content) {
        throw new Error('Serviço indisponível no momento, tente novamente em instantes.');
    }

    dispatch(setBlockChainVerificationPharse(`Welcome to TROK Swap | `+phrase.data.content));
}

export const makeBlockchainSignup = (password:string, nickname:string) : AppThunk<Promise<void>> => async (dispatch, getState) => {

    const state = getState();
    let chain = ``;
    if (state.register.blockChainNetwork === 'eth_flow') chain = 'ethereum-chain';
    if (state.register.blockChainNetwork === 'tron_flow') chain = 'tron-chain';

    try {
        console.dir('signup');
        const reg = await RegisterService.makeSignup(
            state.register.userSignature, 
            state.register.blockChainVerificationPharse, 
            state.register.blockChainNetwork,
            password,
            nickname,
            state.register.blockChainAddress,
            chain
        )
        
        if (reg) {
            
            if (reg.code === 201) {
                
                await dispatch(getUserPhrase(state.register.blockChainAddress));
                await dispatch(makeBlockChainSignin());
                
            } else {
                throw new Error('Error registering new user, $error %s', reg);
            }
            
        } else {
            throw new Error('Error registering new user, $error %s', reg);
        }

    } catch (err) {
        console.dir('Error Signup')
        console.error(err);
    }
}

export const makeBlockChainSignin = () : AppThunk<Promise<void>> => async (dispatch, getState) => {

    const state = getState();
    
    const userSignPorcess = await dispatch(getPhraseSignin());
    if (userSignPorcess.code === 401) throw new Error('Usuario cancelou a assinatura')

    try {

        const response = await RegisterService.makeSignin(
            userSignPorcess,
            state.register.blockChainVerificationPharse, 
            state.register.blockChainNetwork,
            state.register.blockChainAddress,
        )

        if (response?.code === 201) {
            dispatch(setTokens(response));
        } else {

            if (response.response.data.code === 1 || response.response.data.code === 2) {
                dispatch(setIncreaseModalStep(true));
            } else {
                console.dir('No code 200 for ya')
            }
        }        

    } catch (err) {
        console.error('Error no Signin')
        throw err;
    }
}

export const setTokens =  (response:any) : AppThunk<Promise<void>>=> async (dispatch, getState) => {
    dispatch(setIsRegistered(true));
    dispatch(setRefreshTokenForEncryption(response.data.refresh_token));
    dispatch(setAccessTokenLocally(response.data.token));
    dispatch(setModalSignInUp(modalTypeEnum.deviceLogin));
    dispatch(setNotificationButtonLoad(false));
}

export const getPhraseSignin = () : AppThunk<Promise<string|any>> => async (dispatch, getState) => {
    
    const state = getState();

    // Metamask
    if (window.ethereum && state.register.blockChainNetwork === 'eth_flow') {
        const msgHex    = '0x' + Buffer.from(state.register.blockChainVerificationPharse, 'utf8').toString('hex');
        const address   = state.wallet.address;
        try {
            const signature = await walletConnector.signMessage(msgHex, address);
            dispatch(setUserSignature(signature));
            return signature
        } catch (err:any) {
            return err;
        }
    }

    // TRON
    else if (window.tronWeb && window.tronWeb.ready && state.register.blockChainNetwork === 'tron_flow') {
        try {

            const signature = await window.tronWeb.trx.signMessageV2(state.register.blockChainVerificationPharse);
            await dispatch(setUserSignature(signature));
            return signature;
            
        } catch (err) {
            console.error("Signing failed:", err);
            return err;
        }
    }

}


// EXPORT DEFAULT
export default registerSlice.reducer;